// extracted by mini-css-extract-plugin
export default {"table":"Crypto_table__SieeW","head":"Crypto_head__IBGxH","tableRow":"Crypto_tableRow__z3VXv","logo":"Crypto_logo__aiFjN","symbol":"Crypto_symbol__eGaAN"};